import React from 'react';
import {useTranslation} from 'react-i18next';
import {Row, Col} from 'reactstrap';
import {Select, DatePicker} from '@/Form';
import {buildSelectOptions} from '@/components/Form/formHelper';

const MissingPremium = () => {
  const {t: tr} = useTranslation('selection');

  return (
    <Row>
      <Col md={12}>
        <Row>
          <Col md={3}>
            <Select name='followupType' label={tr('report:type')}>
              {buildSelectOptions(tr('followup_type_options'))}
            </Select>
          </Col>
        </Row>
        <label>{tr('report:sr_created_date')}</label>
        <Row>
          <Col md={2}>
            <DatePicker name='dateFrom' />
          </Col>
          <Col md={2} className='pl-1'>
            <DatePicker name='dateTo' />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default MissingPremium;
